export const LOCATION_REFRESH_TIME = 500
export const DISTANCE_AND_TIME_REFRESH_TIME = 5000
export const DISTANCE_OF_TRIGGER_IS_SHOP_VISITED = 15
